import content from '../generated/content.json';

export const jobs = content.experience.jobs;

export function getJobById(id) {
  return jobs.find((job) => job.id === id);
}
